/* iSpice search page + page not found - 2026-10-06
   Small enhancements on top of sections/ispice-search.liquid and ispice-404.liquid.
   Without this script the pages still work: full titles, Add to cart posts the form and goes to /cart.
   - long titles ("iSpice | Name | 4.62 oz | Halal | Kosher") become name + size + tags (same rule as collections)
   - Add to cart stays on the page (fetch to /cart/add.js, which opens the iSpice cart panel)
   - 404: reads words from the broken link, fills the search box and shows matching products or articles */
(function () {
  'use strict';
  var TAGS = ['Organic', 'Salt Free', 'Salt-Free', 'Sugar Free', 'Sugar-Free', 'Halal', 'Kosher', 'Vegan', 'Gluten Free', 'Gluten-Free', 'Non-GMO', 'Keto', 'MSG Free'];
  var SIZE = /\b\d+(?:\.\d+)?\s?(?:oz|ounce|ounces|lb|lbs|g|gr|kg|ml|pack|pk|ct|count)\b/i;
  var STOP = /^(products?|collections?|pages?|blogs?|news|all|ispice|the|and|of|for|with|in|a|an|to|oz|lb|lbs|g|kg|ml|pack|count|tin|jar|bag|can|premium|gourmet|food|service|kosher|halal|organic|certified|usda|non|gmo|free|mixed|spices?|seasonings?|large|small|old|new|copy|test|link|\d.*)$/i;

  function norm(t) { return String(t || '').replace(/\s+/g, ' ').trim(); }
  function esc(t) { return String(t || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function splitTitle(a) {
    if (!a || a.dataset.icDone) return;
    a.dataset.icDone = '1';
    var full = norm(a.textContent);
    var parts = full.split('|').map(norm).filter(Boolean);
    if (parts.length < 2) return;
    if (/^(ispice( blend)?|szeged|spice)$/i.test(parts[0])) parts.shift(); // brand words in front of the real name
    if (!parts.length) return;
    var name = parts.shift(), size = '', tags = [], seen = {};
    parts.forEach(function (p) {
      if (!size && SIZE.test(p)) { size = p.match(SIZE)[0]; return; }
      TAGS.forEach(function (t) {
        var key = t.toLowerCase().replace('-', ' ');
        if (!seen[key] && new RegExp('\\b' + t.replace('-', '[- ]') + '\\b', 'i').test(p)) { seen[key] = 1; tags.push(t.replace('-', ' ')); }
      });
    });
    if (!size && SIZE.test(name)) size = name.match(SIZE)[0];
    name = name.replace(/\s*[–—-]\s*\d+(?:\.\d+)?\s?(?:oz|ounces?|lbs?|g|gr|kg|ml)$/i, ''); // "Sweet Paprika – 10 oz"
    a.setAttribute('title', full);
    a.setAttribute('aria-label', full);
    a.textContent = name;
    var after = a.parentNode;
    if (size) {
      var m = document.createElement('div'); m.className = 'ic-meta'; m.textContent = size;
      after.insertAdjacentElement('afterend', m); after = m;
    }
    if (tags.length) {
      var t = document.createElement('div'); t.className = 'ic-tags';
      tags.slice(0, 3).forEach(function (x) { var s = document.createElement('span'); s.textContent = x; t.appendChild(s); });
      after.insertAdjacentElement('afterend', t);
    }
  }

  function addToCart(e) {
    var form = e.target.closest && e.target.closest('form[data-isx-add]');
    if (!form || !window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding...';
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () {
        btn.classList.add('is-added'); btn.textContent = 'Added';
        // keep the theme's cart counter in step
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          Array.prototype.forEach.call(document.querySelectorAll('.cart_count, .header-cart__count, [data-cart-count]'), function (el) { el.textContent = c.item_count; });
        }).catch(function () {});
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; btn.disabled = false; }, 2200);
      })
      .catch(function (err) {
        console.warn('ispice-search add to cart', err);
        form.removeAttribute('data-isx-add'); form.submit(); // fall back to the normal form post
      });
  }

  // 404: words from the broken link -> search box + suggestions
  function guess(root) {
    var input = root.querySelector('[data-isx-guess]');
    if (!input || root.dataset.isxGuessed) return;
    root.dataset.isxGuessed = '1';
    var segs = location.pathname.split('/').filter(Boolean);
    var isBlog = segs[0] === 'blogs';
    var last = decodeURIComponent(segs[segs.length - 1] || '').replace(/\.[a-z]{2,4}$/i, '');
    var words = last.split(/[-_+\s]+/).filter(function (w) { return w.length > 2 && !STOP.test(w); }).slice(0, 3);
    if (!words.length) return;
    input.value = words.join(' ');
    // all words first; if nothing matches ("cumin guide"), try each word on its own
    var tries = [words.join(' ')].concat(words.length > 1 ? words : []);
    function next() {
      var q = tries.shift();
      if (!q) return;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=' + (isBlog ? 'article' : 'product') +
        '&resources[limit]=4&resources[options][unavailable_products]=last';
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (d) {
        var res = (d && d.resources && d.resources.results) || {};
        var list = isBlog ? res.articles : res.products;
        if (!list || !list.length) return next();
        input.value = q;
        show(root, isBlog, q, list);
      }).catch(function (err) { console.warn('ispice-search 404 suggestions', err); });
    }
    next();
  }

  function show(root, isBlog, q, list) {
    var html = '<div class="isx-sq-block isx-nf-guess"><div class="isx-sq-block__head"><h2>Were you looking for&hellip;</h2>' +
      '<a href="/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">All results for &ldquo;' + esc(q) + '&rdquo;</a></div>';
    if (isBlog) {
      html += '<ul class="isx-sq-pages">' + list.map(function (a) {
        return '<li><a href="' + esc(a.url.split('?')[0]) + '"><b>' + esc(a.title) + '</b><span>' + esc(norm(a.summary_html ? a.summary_html.replace(/<[^>]+>/g, ' ') : '').slice(0, 160)) + '</span></a></li>';
      }).join('') + '</ul>';
    } else {
      html += '<div class="isx-sq-grid">' + list.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        var src = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
        var price = parseFloat(p.price) || 0, was = parseFloat(p.compare_at_price_max) || 0;
        var save = was > price && price ? Math.round((1 - price / was) * 100) : 0;
        var href = esc(p.url.split('?')[0]);
        return '<article class="isx-sq-card"><a class="isx-sq-card__img" href="' + href + '" tabindex="-1" aria-hidden="true">' +
          (src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '') +
          (save >= 5 ? '<span class="isx-sq-card__save">Save ' + save + '%</span>' : '') + '</a>' +
          '<div class="isx-sq-card__body"><h3 class="isx-sq-card__title"><a href="' + href + '" data-isx-title>' + esc(p.title) + '</a></h3>' +
          '<div class="isx-sq-card__price"><span class="isx-sq-card__now' + (save >= 5 ? ' is-sale' : '') + '">$' + price.toFixed(2) + '</span>' +
          (was > price ? '<s class="isx-sq-card__was">$' + was.toFixed(2) + '</s>' : '') + '</div></div>' +
          '<div class="isx-sq-card__buy"><a class="isx-sq-btn is-ghost" href="' + href + '">View product</a></div></article>';
      }).join('') + '</div>';
    }
    html += '</div>';
    var anchor = root.querySelector('.isx-nf-links') || root.querySelector('.isx-sq-head');
    anchor.insertAdjacentHTML('afterend', html);
    Array.prototype.forEach.call(root.querySelectorAll('.isx-nf-guess [data-isx-title]'), splitTitle);
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-isx-sq]'), function (root) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-isx-title]'), function (a) {
        try { splitTitle(a); } catch (e) { console.warn('ispice-search title', e); }
      });
      if (!root.dataset.isxBound) { root.dataset.isxBound = '1'; root.addEventListener('submit', addToCart); }
      try { guess(root); } catch (e) { console.warn('ispice-search 404', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
